import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const PayFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-gray-900 to-black text-white px-6">
      <div className="w-full max-w-md">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl py-8 px-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-red-500/10 p-4 rounded-full">
              <XCircle className="w-10 h-10 text-red-500" />
            </div>
          </div>
          <h1 className="text-xl tracking-tight mb-1">
            Payment Verification Failed
          </h1>
          <p className="text-gray-400 mb-6 text-sm">
            Please contact support
          </p>
          <div className="bg-white/5 border border-white/10 rounded-xl p-2 mb-6">
            <p className="text-sm text-gray-400">Support</p>
            <p className="text-base">Phoenix Play Zone</p>
            <p className="text-red-400 font-semibold">077 760 6279</p>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate("/")}
              className="w-full py-3 rounded-xl bg-white text-black hover:bg-gray-200 transition"
            >
              Back to Home
            </button>
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          Secure payments powered by payhere gateway
        </p>
      </div>
    </div>
  );
};

export default PayFailed;

